import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerService } from '../../../../../../../../../../services/customer/customer.service';
import { OrganizationConfigService } from '../../../../../../../../../../services/organization-config/organization-config.service';
import { CustomerMembership } from '../../../../../../../../../../models/membership';
import { MembershipDiscountType } from '../../../../../../../../../../models/membership-enums';

@Component({
  selector: 'app-edit-recurring-customer-membership-one-off-discount',
  templateUrl: './edit-recurring-customer-membership-one-off-discount.component.html',
  styleUrls: ['./edit-recurring-customer-membership-one-off-discount.component.css']
})
export class EditRecurringCustomerMembershipOneOffDiscountComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public hasExistingDiscount = false;

  public discountType: MembershipDiscountType = MembershipDiscountType.currency;
  public discountAmount: number = null;
  public discountAppliesToAddOns = false;
  public discountName: string = null;
  public removeDiscount = false;

  public errorMessage = '';

  public MembershipDiscountType = MembershipDiscountType;

  private saveClickedSubscription: Subscription;

  constructor(
    public orgConfigService: OrganizationConfigService,
    private activeModal: NgbActiveModal,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });

    this.discountType = this.membership.one_off_discount_type;
    this.discountAmount = parseFloat(this.membership.one_off_discount_amount);
    this.discountAppliesToAddOns = this.membership.one_off_discount_applies_to_add_ons;
    this.discountName = this.membership.one_off_discount_name;

    this.hasExistingDiscount = this.discountAmount > 0;
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  private handleSave() {
    if (this.removeDiscount) {
      this.handleRemoveDiscount();
    } else {
      this.handleEditDiscount();
    }
  }

  private handleEditDiscount() {
    this.loadingEvent.emit(true);

    this.errorMessage = '';

    let actionName = 'edit';
    if (!this.hasExistingDiscount) {
      actionName = 'add'
    }

    this.customerService
      .editCustomerMembershipOneOffDiscount(
        this.membership.id,
        this.discountType,
        this.discountAmount,
        this.discountAppliesToAddOns,
        this.discountName
      )
      .then(() => {
        this.savedCallback('Discount ' + actionName + 'ed successfully.');
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to ' + actionName + ' this discount.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

  private handleRemoveDiscount() {
    this.loadingEvent.emit(true);

    this.errorMessage = '';

    this.customerService
      .editCustomerMembershipOneOffDiscount(
        this.membership.id,
        MembershipDiscountType.currency,
        0,
        false,
        ''
      )
      .then(() => {
        this.savedCallback('Discount removed successfully.');
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove this discount.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

}
